<template>
  <div class="message-template">
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="box">
      <admin-box-item title="메세지 템플릿 설정">
        <div style="margin-bottom: 24px" v-if="send_message_setting!==undefined && send_message_setting.send_type===1">
          <div class="desc">템플릿 내용: 쿨에스엠에스에서 카카오 알림톡 템플릿 등록할 때
            아래 템플릿 내용을 복사해서 붙여 넣으세요.
          </div>
          <div class="desc">(구)버전 사용할 경우 카카오 알림톡 버튼 기능은 제공하지 않습니다.</div>
        </div>
        <admin-form-item label="전송 시점*">
          <lp-adm-drop-input ref="adminput"
                             :data.sync="sendPointArr"
                             :selectVal="sendPointName"
                             @onSelect="selectSendPoint"
                             width="160px"
                             listAlign="center"
                             style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
        </admin-form-item>
        <div v-if="selectedSendPoint!==undefined">
          <admin-form-item label="대상*">
            <lp-adm-drop-input ref="adminput"
                               :data.sync="selectedSendPoint.targets"
                               :selectVal="targetName"
                               @onSelect="res => value.target=res.value"
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
          <admin-form-item label="전송메시지*" tip="SMS, 카카오알림톡에 사용할 수 있는 변수 정보입니다.">
            <div class="selected-send-point-wrapper">
              <div>
                <div style="margin-right:8px;display:inline-block"
                     v-for="(item, item_idx) in selectedSendPoint.variables"
                     :key="`var-${item_idx}`">{{ item.val }}
                </div>
              </div>
            </div>
            <textarea class="textarea-st" v-model="value.content" placeholder="#{회원명}님 가입을 축하드립니다."></textarea>
          </admin-form-item>
        </div>

        <div v-if="send_message_setting!==undefined && send_message_setting.send_type===1">
          <div style="color:#888888;margin:12px 0">카카오 알림톡은 아래 정보를 기입해주세요.</div>
          <admin-form-item label="Sender Key" desc="API v2 이하 버전 전용 파라미터">
            <input class="input"
                   style="width:340px"
                   :value="value.sender_key"
                   @input="e => value.sender_key = e.target.value"
                   type="text"
                   maxlength="50">
            <div class="desc">(구)Sender Key: 쿨에스엠에스에서 알림톡 템플릿의 등록이 완료가 되면 Sender Key를 복사하여 저장해주세요.</div>
          </admin-form-item>
          <admin-form-item label="Template Code" desc="API v2 이하 버전 전용 파라미터">
            <input class="input"
                   style="width:340px"
                   :value="value.template_code"
                   @input="e => value.template_code = e.target.value"
                   type="text"
                   maxlength="50">
            <div class="desc">(구)Template Code: 쿨에스엠에스에서 알림톡 템플릿의 등록이 완료가 되면 Template Code를 복사하여 저장해주세요.</div>
          </admin-form-item>
          <admin-form-item label="pfId">
            <input class="input"
                   style="width:340px"
                   :value="value.pfId"
                   @input="e=> value.pfId = e.target.value"
                   type="text">
            <div class="desc">(신)pfId: 쿨에스엠에스에서 알림톡 템플릿의 등록이 완료가 되면 pfId를 복사하여 저장해주세요.</div>
          </admin-form-item>
          <admin-form-item label="templateId">
            <input class="input"
                   style="width:340px"
                   :value="value.templateId"
                   @input="e=> value.templateId = e.target.value"
                   type="text">
            <div class="desc">(신)templateId: 쿨에스엠에스에서 알림톡 템플릿의 등록이 완료가 되면 templateId를 복사하여 저장해주세요.</div>
          </admin-form-item>

          <admin-form-item label="알림톡 버튼 목록">
            <div class="flex" style="border-bottom:1px solid #ddd;padding-bottom:12px">
              <div style="width:25%">버튼이름</div>
              <div style="width:10%">버튼종류</div>
              <div style="width:65%">버튼링크</div>
            </div>
            <div class="flex" style="border-bottom:1px solid #ddd;padding:12px 0"
                 v-for="(button, b_idx) in value.buttons" :key="`button-${b_idx}`">
              <div style="width:25%;padding:6px">
                <input class="input"
                       style="width:340px"
                       :value="button.buttonName"
                       @input="e=> button.buttonName = e.target.value"
                       type="text">
              </div>
              <div style="width:10%;padding:6px">{{ button.buttonType==='WL'?'웹링크':button.buttonType }}</div>
              <div style="width:65%;padding:6px">
                <div class="flex-align" style="margin-bottom: 8px">
                  <div style="width:80px;margin-right: 4px">모바일링크</div>
                  <input class="input"
                         :value="button.linkPc"
                         @input="e=> button.linkPc = e.target.value"
                         type="text">
                </div>
                <div class="flex-align">
                  <div style="width:80px;margin-right: 4px">PC링크</div>
                  <input class="input"
                         :value="button.linkMo"
                         @input="e=> button.linkMo = e.target.value"
                         type="text">
                </div>
              </div>
              <i class="material-icons unselect" @click="removeButtons(b_idx)">close</i>
            </div>
            <button class="button" style="margin-top:12px;width:120px" @click="addAtaButton">알림톡 버튼 추가</button>
          </admin-form-item>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>
<script>
  import LpDropdown from "../../module/common/LpDropdown";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    name: "MessageTemplateCreate",
    components: {LpAdmDropInput, LpDropdown},
    created() {
      this.init();

      //  붙여넣기 감지후 토스트..
    },
    data() {
      return {
        sendMessageTemplate: [],
        sendPointArr: [],
        selectedSendPoint: undefined,
        value: {
          name: '',
          target: '',
          content: '',
          template_code: '',
          sender_key: '',
          pfId: '',
          templateId: '',
          buttons: []
        },
        send_message_setting: undefined
      }
    },
    computed: {
      sendPointName() {
        if (this.value.name && this.selectedSendPoint) {
          return this.selectedSendPoint.label;
        }
        return ''
      },
      targetName() {
        if (this.value.target && this.selectedSendPoint) {
          let data = find(this.selectedSendPoint.targets, 'value', this.value.target);
          if (data) {
            return data.label;
          }
        }
        return ''
      }
    },
    methods: {
      async init() {
        await this.getSendMessageTemplate();
        await this.getSendPoint();
        await this.getSendMessageSetting();
        if (this.$route.query.id) await this.getData();
      },
      async getSendMessageTemplate() {
        await this.$axios.get(this.getUrl('sms/send_message_template?page_length=100')).then(res => {
          this.sendMessageTemplate = res.data.data;
        })
      },
      // 전송 시점 목록
      async getSendPoint() {
        await this.$axios.get('admin/sms/send_point').then(res => {
          if (res.status) {
            let result = res.data;
            if (result.length > 0) {
              result.forEach(item => {
                delete item.name;
              })
            }
            // 등록 페이지
            if(!this.$route.query.id) {
              let send_point_name_list = this.sendMessageTemplate.map(item=>{ return item.name })
              for(let i=result.length-1; i>=0; i--) {
                if(send_point_name_list.indexOf(result[i].value)>-1) {
                  result.splice(i, 1);
                }
              }
            }
            this.sendPointArr = result;
            /*if(this.$route.query.id) {
              this.sendPointArr = result;
            } else {
              let sendPointArr = [];
              for(let i=0; i<result.length; i++) {
                let template = find(this.sendMessageTemplate, 'name', result[i].value);
                if(!template) {
                  sendPointArr.push(result[i]);
                }
              }
              this.sendPointArr = sendPointArr;
            }*/
          }
        })
      },
      // 전송 시점 선택
      selectSendPoint(res) {
        this.value = {
          name: '',
          target: '',
          content: '',
          template_code: '',
          sender_key: '',
          pfId: '',
          templateId: '',
          buttons: []
        }
        this.value.name = res.value;
        this.selectedSendPoint = res;

        this.$nextTick(() => {
          this.value.content = '';
        })
      },
      // 변수 선택
      selectVariable(item) {
        let selection = window.getSelection();
        let newRange = selection.getRangeAt(0)
        let className = newRange.startContainer.className;
        if (className !== 'selected-send-point-wrapper') {
          className = newRange.startContainer.parentNode.className;
        }
        if (className === 'selected-send-point-wrapper') {
          let tmpNode = document.createElement('span');
          tmpNode.innerHTML = `${item.html}&nbsp;`;
          newRange.insertNode(tmpNode);
        } else {
          this.$refs.editor.innerHTML += `${item.html}&nbsp;`;
        }
      },
      async getData() {
        await this.$axios.get(`admin/sms/send_message_template/${this.$route.query.id}`).then(res => {
          this.value = res.data;

          let data = find(this.sendPointArr, 'value', this.value.name);
          if (data) {
            this.selectedSendPoint = data;
            this.$nextTick(() => {
              this.value.content = this.replaceVariable(this.value.content);
            })
          }
        })
      },
      saveData() {
        let value = this.cloneItem(this.value);
        let error = '';
        if (!value.name) {
          error = '전송 시점을 선택해주세요.';
        }
        if (!value.content) {
          error = '전송메시지를 입력해주세요.';
        }
        if (!value.target) {
          error = '전송대상을 선택해주세요.';
        }
        if (error) {
          this.toast(error);
          return;
        }
        value.content = this.replaceVariable(this.value.content, 1);
        if (this.$route.query.id !== undefined) {
          this.$axios.patch(`admin/sms/send_message_template/${this.$route.query.id}`, value).then(res => {
            this.toast('저장되었습니다.');
            this.init();
          })
        } else {
          this.$axios.get('admin/sms/send_message_template/name/check', {
            params: {
              name: this.value.name,
              target: this.value.target
            }
          }).then(res => {
            this.$axios.post('admin/sms/send_message_template', value).then(res => {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('sms_message_template'));
            })
          }).catch(error => {
            if (error.response) {
              if (error.response.data.message) {
                this.toast(error.response.data.message);
              } else {
                this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
              }
            } else {
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          })
        }
      },
      replaceVariable(content, type) {
        this.selectedSendPoint.variables.forEach(item => {
          // 한글에서 변수로 변경
          if (type === 1) {
            content = content.replaceAll(item.val, `#{${item.key}}`);
            //  변수에서 한글로 변경
          } else {
            content = content.replaceAll(`#{${item.key}}`, item.val);
          }
        })
        return content;
      },
      // 메시지 템플릿 설정
      async getSendMessageSetting() {
        await this.$axios.get('admin/sms/send_message/setting').then(res => {
          this.send_message_setting = res.data;
        })
      },
      addAtaButton() {
        let data = {
          buttonType: 'WL',
          buttonName: '',
          linkMo: '',
          linkPc: ''
        }
        this.value.buttons.push(data)
      },
      removeButtons(idx) {
        removeIndex(this.value.buttons, idx);
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .message-template .textarea-st
    padding 12px
    width 100%
    height 500px
    outline none
    margin-top 24px
    border 1px solid #ddd

  .message-template .desc
    font-size 0.8rem
    margin-top 4px
    color #787878

  .selected-send-point-wrapper
    border 1px solid #ddd
    padding 12px

  .selected-send-point-wrapper:last-child
    margin-top 12px

  .variable-st
    padding 2px 10px
    border-radius 6px
    margin-bottom 8px
    display inline-block
    background-color $primary
    color white
</style>
<style lang="stylus">
  @import '~assets/css/lp_main'
  .message-template .variable-st
    padding 2px 10px
    border-radius 6px
    margin-bottom 8px
    display inline-block
    background-color $primary
    color white
</style>
